import { render, staticRenderFns } from "./record-filter.vue?vue&type=template&id=2e997ee2&scoped=true"
import script from "./record-filter.vue?vue&type=script&lang=js"
export * from "./record-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e997ee2",
  null
  
)

export default component.exports